import { inject, signal, Signal } from '@angular/core';
import { injectQuery } from '@tanstack/angular-query-experimental';
import { environment } from 'src/environments/environment';

import { EntitySettingTypes, EntityType, GqlService } from '@shared/services/gql.service';
import { MainQuery } from '@shared/store/main/main.query';
import { gqlToPromise } from '@shared/utils/gql-to-promise';

export const injectGetAllVendorBalanceSheetsQuery = ({
  enabled = true,
  vendorIdsSignal = signal([]),
}: {
  enabled?: boolean;
  vendorIdsSignal: Signal<string[]>;
}) => {
  const gqlService = inject(GqlService);
  const mainQuery = inject(MainQuery);

  return injectQuery(() => ({
    enabled: enabled && !!vendorIdsSignal() && vendorIdsSignal().length > 0,
    queryFn: () => {
      if (environment.usePlayground) {
        return import('./get-all-vendor-balance-sheets.query.mock').then(
          (m) => m.getAllVendorBalanceSheetsQueryMock.data.listEntitySettings
        );
      }

      const currentVendorIds = vendorIdsSignal();

      return gqlToPromise(() => {
        return gqlService.listEntitySettings$({
          entity_ids: currentVendorIds,
          entity_type: EntityType.ORGANIZATION,
          setting_type: EntitySettingTypes.VENDOR_ACCOUNTS,
        });
      });
    },
    queryKey: [
      'trials',
      'detail',
      mainQuery.trialKey(),
      'listAllVendorBalanceSheetSettings',
      [...(vendorIdsSignal() || [])].sort(),
    ],
  }));
};
